<template>
	<div class="htmlBox" v-if="userInfo.member">
		<router-link :to="{ path: '/changeMobile', query: { phone: userInfo.member.phone_mob } }">
			<div class="mobile_list">
				<p class="fl" >{{ userInfo.member.name }} {{ userInfo.member.phone_mob }}</p>
				<p class="fr red">更改绑定</p>
			</div>
		</router-link>
	</div>
</template>

<script>
import { sendRequest } from '@/assets/public';

export default {
	data() {
		return {
			userInfo: {} //用户信息
		};
	},
	created() {
		// 获取用户信息
		this.getInfoData();
	},
	methods: {
		// 获取用户信息
		async getInfoData() {
			let res = await sendRequest('user/info', {type:'0'});
			if (res.status == 200) {
				this.userInfo = res.content;
			}
		}
	}
};
</script>
<style scoped>
.htmlBox {
	height: 100%;
	display: block;
	background: #f5f5f5;
}
.mobile_list {
	padding: 0 0.8rem;
	height: 1.76rem;
	line-height: 1.76rem;
	overflow: hidden;
	background: #fff;
	margin-top: 0.4rem;
}
.mobile_list p {
	color: #333333;
	font-size: 0.56rem;
}
</style>
